import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AddPaymentModalState = {
    billingAddress : string,
    billingCity : string,
    billingState : string,
    billingZip : string,
    cardHolderName : string,
    expirationDate : string
}

const initialState : AddPaymentModalState = {
    billingAddress: "",
    billingCity: "",
    billingState: "",
    billingZip: "",
    cardHolderName: "",
    expirationDate: ""
}

export const addPaymentModalSlice = createSlice({
    name: 'addPaymentModal',
    initialState: initialState,
    reducers: {
        updateBillingAddress: (state, action : PayloadAction<string>) => {
            state.billingAddress = action.payload;
        },
        updateBillingCity: (state, action : PayloadAction<string>) => {
            state.billingCity = action.payload;
        },
        updateBillingState: (state, action : PayloadAction<string>) => {
            state.billingState = action.payload;
        },
        updateBillingZip: (state, action : PayloadAction<string>) => {
            state.billingZip = action.payload;
        },
        updateCardHolderName: (state, action : PayloadAction<string>) => {
            state.cardHolderName = action.payload;
        },
        updateExpirationDate: (state, action : PayloadAction<string>) => {
            state.expirationDate = action.payload;
        },
    }
});

export const {
    updateBillingAddress,
    updateBillingCity,
    updateBillingState,
    updateBillingZip,
    updateCardHolderName,
    updateExpirationDate
} = addPaymentModalSlice.actions;

export default addPaymentModalSlice.reducer;